export const NOTIFICATION_DISPLAY_TIME = 5000;

export const SUPPORT_PHONE_NUMBER = '(866)-526-0083';

export const SMB_SUPPORT_EMAIL = 'business.support@arcadia.com';
